'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModalService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Show simple modal windows with pre-defined templates. E.g. to replace
// browser's confirm.
var ModalService = exports.ModalService = function () {
    function ModalService($uibModal, $q) {
        _classCallCheck(this, ModalService);

        this.$uibModal = $uibModal;
        this.$q = $q;
        this.test = 'test';
    }

    // Displays a modal with two options
    //
    // +--------------------------------------------------+
    // | [title goes here]                                |
    // +--------------------------------------------------+
    // | [message goes here]                              |
    // | [yes goes here] [no goes here]                   |
    // +--------------------------------------------------+
    //
    //
    // Returns a promise that gets called with true / false based on user input.
    //
    // Default value of okText is common.ok and cancelText is common.cancel


    _createClass(ModalService, [{
        key: 'confirm',
        value: function confirm(title, message, okText, cancelText) {
            return this.modal(title, message, [{
                Class: 'btn-primary',
                Text: okText ? okText : 'common.ok',
                Result: true
            }, {
                Class: 'btn-danger',
                Text: cancelText ? cancelText : 'common.cancel',
                Result: false
            }]);
        }

        // Like confirm, but Yes text is Yes and no text is No. (as opposed to
        // cancel /

    }, {
        key: 'yesNo',
        value: function yesNo(title, message) {
            return this.confirm(title, message, 'common.yes', 'common.no');
        }

        // Displays a modal with any number of options
        //
        // +--------------------------------------------------+
        // | [title goes here]                                |
        // +--------------------------------------------------+
        // | [message goes here]                              |
        // | [buttons go here]                                |
        // +--------------------------------------------------+
        //
        // When user clicks a button, the returned promise is resolved with the
        // selected Result.
        //
        // Structure of buttons is as follows:
        // [
        //    {
        //      Class: 'btn-danger',
        //      Text: 'common.no',
        //      Result: 'no'
        //    },
        //    {
        //      Class: 'btn-primary',
        //      Text: 'common.yes',
        //      Result: true
        //    }
        // ]

    }, {
        key: 'modal',
        value: function modal(_title, _message, _buttons) {
            var _this = this;

            return this.$q(function (resolve, reject) {
                if (_buttons.length == 0) {
                    reject();
                    return;
                }

                _this.$uibModal.open({
                    template: require('./modalServiceModal.html'),
                    controller: 'ModalServiceController',
                    controllerAs: '$ctrl',
                    windowClass: _this.webComponentStyle ? 'winres-web-component modal-service-modal' : 'modal-service-modal',
                    resolve: {
                        title: function title() {
                            return _title;
                        },
                        message: function message() {
                            return _message;
                        },
                        buttons: function buttons() {
                            return _buttons;
                        },
                        onResult: function onResult() {
                            return resolve;
                        }
                    }
                });
            });
        }
    }]);

    return ModalService;
}();

ModalService.$inject = ['$uibModal', '$q'];

_module3.default.service('modalService', ModalService);


//////////////////
// WEBPACK FOOTER
// ./src/core/modalService/modalService.js
// module id = 71
// module chunks = 0 2